"use strict";
// Forecast type definitions — mirrors Django DRF API response shapes.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=forecast.js.map